import jwt_decode from 'jwt-decode'
export default {
    name: "SendCompanyStatistics",
    created: function () {
        this.init();
    },
    data() {
        return {
            searchForm: {
                signer: '',
                blNo: null,
                billCreateTime: null,
                billPrintTime: null,
                receiveCompanyName: null,
                pageIndex: 1,
                pageSize: 50
            },
            tableData: [],
            selected: [],
            total: 0,
            // 公司下拉列表
            companyList: []
        }
    },
    computed: {
        rules() {
            return {
                signer: [
                    {
                        required: true, //是否必填
                        message: this.$t('c_addWriteBill.message.signer'), //提示信息
                        trigger: 'blur'  //何事件触发
                    }
                ],
                verificationCode: [
                    { required: true, message: this.$t('s_BillApplyPayManage.verificationCodePlaceholder'), trigger: 'blur' },
                ],
            }
        },
        singCompanyList() {
            if (this.searchForm.receiveCompanyName && this.searchForm.signer) {
                if (this.searchForm.receiveCompanyName === this.searchForm.signer) {
                    const id = this.searchForm.receiveCompanyName;
                    return [{ id: id, companyName: this.getCompanyName(id) }]
                } else {
                    const isId = this.searchForm.receiveCompanyName;
                    const sid = this.searchForm.signer;
                    return [{ id: isId, companyName: this.getCompanyName(isId) },
                    { id: sid, companyName: this.getCompanyName(sid) }]
                }
            }
            return [];
        },
    },
    methods: {
        init() {
            // 查询当前提单中的收单公司建立合作关系的出单公司下拉列表
            const selectSendCompanyParam = {};
            const token = jwt_decode(sessionStorage.getItem('token'));
            selectSendCompanyParam.receiveCompanyId = token.customerCompanyId;
            this.$axios({
                method: "get",
                url: "api/customerCompay/selecCompayCustomer",
                params: selectSendCompanyParam
            }).then(res => {
                this.companyList = res.data.resultData;
            }).catch(error => {
                console.log(error);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });
        },
        handleSizeChange(val) {
            this.searchForm.pageSize = val;
            this.doSearch();
        },
        handleCurrentChange(val) {
            this.searchForm.pageIndex = val;
            this.doSearch();
        },
        doReset() {
            this.$refs.searchForm.resetFields();
        },
        doSearch() {
            const param = this.$paramUtil.clearEmpty(this.searchForm);
            // 创建时间
            if (this.searchForm.billCreateTime) {
                param.billCreateBeginTime = this.searchForm.billCreateTime[0];
                param.billCreateEndTime = this.searchForm.billCreateTime[1];
                delete param.billCreateTime;
            }
            // 打印时间
            if (this.searchForm.billPrintTime) {
                param.billPrintBeginTime = this.searchForm.billPrintTime[0];
                param.billPrintEndTime = this.searchForm.billPrintTime[1];
                delete param.billPrintTime;
            }

            const token = sessionStorage.getItem('token');
            const tokenJson = jwt_decode(token);
            // 查询出单费公司id为当前登录人公司id
            param.sendBillFeeCompanyId = tokenJson.customerCompanyId;
            this.$axios.get('/api/statistical/sendCompanyStatistics', { params: param }).then(response => {
                this.tableData = response.data.resultData.rows;
                this.total = response.data.resultData.total;
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });
        },
        getCompanyName(id) {
            let companyName = '';
            this.companyList.forEach(item => {
                if (id === item.id) {
                    companyName = item.companyName;
                }
            });
            return companyName;
        }
    }
}
